import React from 'react';
import {
  createBrowserRouter,
  RouterProvider,
  RouterProviderProps,
} from 'react-router-dom';

import { createRoot } from 'react-dom/client';
import { initSentry } from '~/contexts/MonitoringProvider';
import { routeConfig } from '~/core/Router';

initSentry();

const render = (appRouter: RouterProviderProps['router']) => {
  const container = document.getElementById('root');
  if (!container) throw Error('Failed to create React root');
  const root = createRoot(container);
  root.render(<RouterProvider router={appRouter} />);
};
render(createBrowserRouter(routeConfig));
